import { useState } from 'react';
import SectionTitle from '@/components/base/SectionTitle';

const faqs = [
  {
    q: '《师兄啊师兄》讲的是什么故事？',
    a: '这是一部热血仙侠动画，讲述身患绝症的李长寿意外重生到封神大战前的上古洪荒，成为度仙门炼气士。他奉行「稳健」的生存哲学，隐藏底牌、谋定后动，在残酷的洪荒中低调求生的故事。',
  },
  {
    q: '本站的考据内容从哪来？',
    a: '所有人物关系、CP线、师门日常整理，均基于动画正片的逐集梳理与同好讨论归纳，旨在帮助大家快速理解人物脉络与剧情细节，供交流分享。',
  },
  {
    q: '追更指南会持续更新吗？',
    a: '会的。新一季更新、人物关系图谱调整、名场面盘点都会持续补充。订阅邮箱后，有重要更新时会第一时间提醒你。',
  },
  {
    q: '想投稿考据或指正内容，怎么联系？',
    a: '欢迎通过「关于我们」页面的联系方式与我们沟通，也欢迎同好来信补充细节、共同完善这份追更指南。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <SectionTitle align="center" mark="答疑" title="常见问题" subtitle="关于作品与本站的常见疑问，一次讲清楚。" />
        <div className="divide-y divide-background-200/70 overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
          {faqs.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left transition-colors hover:bg-background-100/60"
                >
                  <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{f.q}</span>
                  <i
                    className={`flex-shrink-0 text-lg text-primary-500 transition-transform ${open ? 'ri-subtract-line' : 'ri-add-line'}`}
                  />
                </button>
                {open && <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}